module.exports = __webpack_public_path__ + "0a0f2e5339c8973152d84994dfd1b533.svg";